<!--
 * @Author:
 * @Description: 权限变更记录
-->
<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <div class="flex justify-between">
      <div>
        <el-select
          v-model="search.changeType"
          clearable
          filterable
          class="w-200px ml-10px mr-10px"
          placeholder="变更类型"
          size="small"
        >
          <el-option
            v-for="(item, index) in typeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="searchList">搜索</el-button>
      </div>
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
    <div class="mt-20px h-full">
      <el-table
        class="mt-20px"
        v-loading="tableLoading"
        border
        height="calc(100% - 100px)"
        :data="tableData"
        ref="multipleTable"
      >
        <el-table-column type="index" width="55" label="序号">
          <template slot-scope="scope">
            {{ scope.$index + 1 + page.pageSize * (page.pageNo - 1) }}
          </template>
        </el-table-column>
        <el-table-column label="实体名称" prop="className" show-overflow-tooltip></el-table-column>
        <el-table-column label="实体表名" prop="tableName" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="授权范围"
          prop="authorizationRange"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="授权规则"
          prop="authorizationRule"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="授权修改时间"
          prop="modifyTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="授权修改人"
          prop="modifyUserName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="变更类型" prop="changeType" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.changeType === 0 ? '新增授权' : '删除授权' }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import DataPermissionsService from '@/services/DataPermissionsService'

export default {
  name: 'permissionChangeRecords',
  data() {
    return {
      typeList: [
        { label: '新增授权', value: 0 },
        { label: '删除授权', value: 1 },
      ],
      search: {
        changeType: null,
      },
      tableLoading: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  computed: {},
  created() {
    this.getTableList()
  },
  methods: {
    // 搜素
    searchList() {
      this.page.pageNo = 1
      this.getTableList()
    },
    // 获取列表数据
    async getTableList() {
      this.tableLoading = true
      const res = await DataPermissionsService.getChangeLogs({
        classId: this.$route.query.classId,
        authorizationClassId: this.$route.query.authorizationClassId,
        authorizationDimensionId: this.$route.query.authorizationDimensionId,
        changeType: this.search.changeType,
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
      this.tableLoading = false
    },
  },
}
</script>
